module.exports = __webpack_public_path__ + "static/media/10.d10e231a.jpg";